var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("loader")
    : _c("div", { staticClass: "row header" }, [
        _c(
          "div",
          { staticClass: "col-lg-3 col-md-12 my-auto d-flex dropdown" },
          [
            _c(
              "a",
              {
                staticClass:
                  "clickable dropdown-toggle primary-arrow text-truncate medium-link",
                attrs: {
                  id: "title-dropdown",
                  "data-toggle": "dropdown",
                  "aria-haspopup": "true",
                  "aria-expanded": "false",
                },
              },
              [_vm._v("\n      " + _vm._s(_vm.boardName) + "\n    ")]
            ),
            _vm._v(" "),
            _c("boards-dropdown", {
              staticClass: "big-dropdown",
              attrs: {
                boards: _vm.boardsOptions,
                "board-id": _vm.selectedBoardId,
                order: "",
                create: "",
              },
              on: {
                select: _vm.handleBoardSelect,
                create: _vm.handleDropdownSelection,
                order: _vm.handleOrderBoards,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-12 col-lg-9 text-right justify-content-start justify-content-lg-end search-container align-items-center d-flex flex-row flex-wrap flex-sm-nowrap",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "text-left search-side my-xl-0 my-2 my-md-0 d-flex flex-row flex-nowrap w-auto",
              },
              [_vm.isDynamicView ? _c("boards-toolbar") : _vm._e()],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-row align-items-center right-inner-addon w-80 w-lg-auto",
              },
              [
                _c("i", {
                  staticClass: "fa fa-search",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "form-control search-clients",
                  attrs: {
                    id: "search-client",
                    type: "search",
                    placeholder: _vm.searchFor,
                  },
                  domProps: { value: _vm.clientProfileSearchString },
                  on: {
                    input: function ($event) {
                      return _vm.handleSearchChange($event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "d-none", attrs: { for: "search-client" } },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("application.listing.searchForClients"))
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-row align-items-center justify-content-lg-center justify-content-end ml-xl-5 ml-lg-4 ml-md-3 ml-0 order-1 order-md-2 w-auto my-xl-0",
              },
              [
                _c("board-actions-dropdown", {
                  attrs: {
                    "is-default-board": _vm.isDefaultBoard,
                    loading: _vm.loadingBoardAction,
                    "board-view": _vm.clientBoardView,
                    "is-owner": _vm.isOwner,
                    "track-emails": _vm.trackEmails,
                  },
                  on: { select: _vm.handleDropdownSelection },
                }),
                _vm._v(" "),
                _c("create-client-modal"),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "add-client-profile btn btn-primary btn-sm d-none d-lg-block",
                    on: { click: _vm.showCreateClient },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("boards.actions.createNewClient")) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }